<div class="flex flex-col items-start gap-2">
  <button
    mat-button
    class="range"
    *ngFor="let range of ranges; trackBy: trackByValue"
    (click)="rangeSelected.emit(range)"
  >
    {{ range.label }}
  </button>
</div>
